import { urlServices } from "./param-url.constants";

export const urlServicesGlobalCat = {
    //login/labels/languages
    lanLogin : urlServices.urlServiceGlobalCat + 'login/labels/languages',
    //cities/keys/{stateKey}
    catCities : urlServices.urlServiceGlobalCat + 'cities/keys/',
    //cities/keys/{stateKey}/{cityKey}
    catCity : urlServices.urlServiceGlobalCat + 'cities/keys/',    
    //countries/all
    catCountries : urlServices.urlServiceGlobalCat + 'countries/all',
    //countries/ids/{countryId}
    catCountry : urlServices.urlServiceGlobalCat + 'countries/ids/',
    //educations/all
    catEducations : urlServices.urlServiceGlobalCat + 'educations/all',
    //educations/category
    catEducationsByCategory : urlServices.urlServiceGlobalCat + 'educations/category',
    //educations/keys/{educationKey}
    catEducation : urlServices.urlServiceGlobalCat + 'educations/keys/',
    //genders/all
    catGenders : urlServices.urlServiceGlobalCat + 'genders/all',
    //genders/ids/{genderId}
    catGender : urlServices.urlServiceGlobalCat + 'genders/ids/',
    //languages /all
    catLanguages : urlServices.urlServiceGlobalCat + 'languages/all',
    //genders/ids/{genderId}
    catLanguage: urlServices.urlServiceGlobalCat + 'languages/ids/',    
    //neighborhoods/all
    catNeighborhoods : urlServices.urlServiceGlobalCat + 'neighborhoods/all',
    //neighborhoods/names/{neighborhood}
    catNeighborhoodByName : urlServices.urlServiceGlobalCat + 'neighborhoods/names/',
    //neighborhoods/ids/{neighborhoodId}
    catNeighborhoodById : urlServices.urlServiceGlobalCat + 'neighborhoods/ids/',
    //states/all
    catStates : urlServices.urlServiceGlobalCat + 'states/all',
    //states/keys/{stateKey}
    catState : urlServices.urlServiceGlobalCat + 'states/keys/',
    //street-types/all
    catStreetTypes : urlServices.urlServiceGlobalCat + 'street-types/all',
    //street-types/ids/{streetTypeId}
    catStreetType : urlServices.urlServiceGlobalCat + 'street-types/ids/',
    //towns/keys/{stateKey}/{cityKey}
    catTown : urlServices.urlServiceGlobalCat + 'towns/keys/',
    //towns/keys-ord/{stateKey}/{cityKey}
    catTownOrd : urlServices.urlServiceGlobalCat + 'towns/keys-ord/',
    //zip-codes/zcs/{zipCode}
    catZipCode : urlServices.urlServiceGlobalCat + 'zip-codes/zcs/',
    //zip-codes/zcs-ord/{zipCode}
    catZipCodeOrd : urlServices.urlServiceGlobalCat + 'zip-codes/zcs-ord/',
    //zip-codes/keys/{stateKey}/{cityKey}
    catZipCodeKeys : urlServices.urlServiceGlobalCat + 'zip-codes/keys/',

    specility:{
        filter:urlServices.urlServiceGlobalCat +'speciality/filter',
        list:urlServices.urlServiceGlobalCat +'speciality/list',
        edit:urlServices.urlServiceGlobalCat +'speciality/edit',
        new:urlServices.urlServiceGlobalCat +'speciality/new',
        delete:urlServices.urlServiceGlobalCat +'speciality/',
        get:urlServices.urlServiceGlobalCat +'speciality/',
    }
};